export default __webpack_public_path__ + "static/media/squareprofileimg.f5f2aa0b.png";